import { Taxonomy } from 'app/model/taxonomy';
import { RestfulApiService } from 'app/services/restful-api.service';

class TaxonomyService extends RestfulApiService<Taxonomy> {
    protected getFormName(): string {
        return 'taxonomy';
    }

    protected getPath(): string {
        return 'taxonomies';
    }
}

export const taxonomyService = new TaxonomyService();
